import { render } from "./Page.vue?vue&type=template&id=6b9ca19c"
import script from "./Page.vue?vue&type=script&lang=ts"
export * from "./Page.vue?vue&type=script&lang=ts"
script.render = render

export default script